import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Title } from '../../../../components';

import Table from '../../../../components/Table';
import { useNavigate } from '../../../../hooks';
import {
  DictumProduct,
  TableOrderDirection
} from '../../../../interfaces';

interface Props {
  lookInTheTrash: boolean
  products: DictumProduct[]
  orderBy: string
  orderDirection: TableOrderDirection
  setOrderBy: (_value: string) => void
  setOrderDirection: (_value: TableOrderDirection) => void
  setCurrentPage: (_value: number) => void
  totalItems: number
  currentPage: number
  changePagination: boolean
  setChangePagination: (_value: boolean) => void
}

const DictumServiceDetailHistory: React.FC<Props> = (props) => {
  const {
    lookInTheTrash,
    products,
    totalItems,
    orderBy,
    orderDirection,
    setOrderBy,
    setOrderDirection,
    currentPage,
    setCurrentPage,
    changePagination,
    setChangePagination
  } = props;

  const { t } = useTranslation();

  const navigate = useNavigate();

  const [anyProductHaveSubInvoice, setAnyProductHaveSubInvoice] = useState<boolean>(false);

  useEffect(() => {
    products.forEach((product) => {
      if (product.subInvoice !== 0) {
        setAnyProductHaveSubInvoice(true);
      }
    });
  }, [products]);

  return (
    <div className="dictum-service-detail__table" id="data-section">
      <Title title={t('global.products')} type="primary" />
      <br />
      <Table
        headers={anyProductHaveSubInvoice ? [
          {
            label: t('tasks.table.invoice'),
            value: 'invoice',
            format: 'none'
          },
          {
            label: t('global.subInvoice'),
            value: 'subInvoice',
            format: 'none'
          },
          {
            label: t('global.status.title'),
            value: 'status',
            format: 'status'
          },
          {
            label: 'Inspector',
            value: 'inspector.name',
            format: 'person-name',
            onlyAdmin: true
          },
          {
            label: t('services.roundTitle'),
            value: 'round',
            format: 'none'
          },
          {
            label: t('global.norm'),
            value: 'normCode',
            format: 'none'
          },
          {
            label: t('global.description'),
            value: 'description',
            format: 'none',
            limitLength: 30
          },
          {
            label: t('services.labelingMode'),
            value: 'labelingMode',
            format: 'none'
          },
          {
            label: t('global.code'),
            value: 'code',
            format: 'none',
            limitLength: 40
          },
          {
            label: t('global.model2'),
            value: 'code2',
            format: 'none',
            limitLength: 40
          },
          {
            label: t('global.brand'),
            value: 'brand',
            format: 'none'
          },
          {
            label: t('global.approver'),
            value: 'approver.name',
            format: 'person-name',
            onlyAdmin: true
          }
        ] : [
          {
            label: t('tasks.table.invoice'),
            value: 'invoice',
            format: 'none'
          },
          {
            label: t('global.status.title'),
            value: 'status',
            format: 'status'
          },
          {
            label: 'Inspector',
            value: 'inspector.name',
            format: 'person-name',
            onlyAdmin: true
          },
          {
            label: t('services.roundTitle'),
            value: 'round',
            format: 'none'
          },
          {
            label: t('global.norm'),
            value: 'normCode',
            format: 'none'
          },
          {
            label: t('global.description'),
            value: 'description',
            format: 'none',
            limitLength: 30
          },
          {
            label: t('services.labelingMode'),
            value: 'labelingMode',
            format: 'none'
          },
          {
            label: t('global.code'),
            value: 'code',
            format: 'none',
            limitLength: 40
          },
          {
            label: t('global.model2'),
            value: 'code2',
            format: 'none',
            limitLength: 40
          },
          {
            label: t('global.brand'),
            value: 'brand',
            format: 'none'
          },
          {
            label: t('global.approver'),
            value: 'approver.name',
            format: 'person-name',
            onlyAdmin: true
          }
        ]}
        items={products}
        currentPage={currentPage}
        perPage={10}
        totalItems={totalItems}
        orderBy={orderBy}
        orderDirection={orderDirection}
        onChangeCurrentPage={(newCurrentPage: number) => {
          setChangePagination(!changePagination);
          setCurrentPage(newCurrentPage);
        }}
        onChangeOrder={(newOrderBy: string, newOrderDirection: TableOrderDirection) => {
          setOrderBy(newOrderBy);
          setOrderDirection(newOrderDirection);
          setCurrentPage(1);
          setChangePagination(!changePagination);
        }}
        onClickRow={(product: DictumProduct) => {
          navigate(`/dictum-products/detail/${product.id}/${lookInTheTrash ? 'true' : 'none'}`);
        }}
      />
    </div>
  );
};

export default DictumServiceDetailHistory;
